// Copyright 2020 The Nakama Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export interface ApiStorageObject {
  collection: string;
  key: string;
  user_id: string;
  value: string;
  version: string;
  permission_read: number;
  permission_write: number;
  create_time: string;
  update_time: string;
}

export interface StorageObjectList {
  objects: ApiStorageObject[];
  cursor: string;
}

export interface StorageSearchFilters {
  collection?: string;
  key?: string;
  user_id?: string;
}

export interface StorageObjectRequest {
  collection: string;
  key: string;
  user_id: string;
  value?: string;
  version?: string;
  permission_read?: number;
  permission_write?: number;
}

export interface DeleteStorageObjectRequest {
  object_ids: {
    collection: string;
    key: string;
    user_id: string;
    version?: string;
  }[];
}

export enum StoragePermission {
  NO_READ = 0,
  OWNER_READ = 1,
  PUBLIC_READ = 2
}

export enum StorageWritePermission {
  NO_WRITE = 0,
  OWNER_WRITE = 1
}
